var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"l-content full relative page-bg"},[(_vm.monitorData)?_c('head-panel',{attrs:{"monitor-data":_vm.monitorData,"config":_vm.config,"condition":_vm.condition},on:{"change":_vm.change}}):_vm._e(),(_vm.monitorData)?_c('chart-container',{attrs:{"monitor-data":_vm.monitorData,"config":_vm.config}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }